import { Component, EventEmitter,  Input, OnInit, Output } from '@angular/core';
import { DialogService } from 'src/app/services/dialog/dialog.service';
import { UserStoreService } from 'src/app/services/user/user-store.service';

@Component({
  selector: 'app-selectable-reverses-card',
  templateUrl: './selectable-reverses-card.component.html',
  styleUrls: ['./selectable-reverses-card.component.scss'],
})
export class SelectableReversesCardComponent implements OnInit {
  @Input() label: string;
  @Input() showIcons: string;
  @Input() option: string;
  @Input() type: string;
  @Input() groupValue: string;
  @Input() groupValueMod: string;
  @Input() content: string;
  @Input() showLabel: true;
  @Input() showLabelSimple: true;
  @Input() showTrash: false;
  @Input() showEdit: true;
  @Input() deleteTitle: string;
  @Output() delete = new EventEmitter<string>();
  @Output() select = new EventEmitter<string>();
  @Output() edit = new EventEmitter<string>();
  
  constructor(public userStore: UserStoreService,
    private dialogService: DialogService,) {}

  ngOnInit() {

  }

  isShowIcons(){
    if(this.showIcons && this.content.split('-')){
      return this.content.split('-')[1] === '01'
    }
  }

  isSelected() {
    const current = this.groupValueMod ? this.groupValueMod : this.groupValue;
    return current ? current === this.option : false;
  }

  isDefault() {
    const current = this.groupValue;
    return current ? current === this.option : false;
  }

  selects(param){
    this.select.emit(param);
  }

  edits(param){
    this.edit.emit(param);
  }

  isBig() {
    return this.type === 'big';
  }

  haveCuc() {
    return this.userStore.activeCUC ? this.userStore.activeCUC.cuc : null
  }

  cancel(param) {
    this.showCancelModal(param)
  }

  showCancelModal(param){
      var options =  {
        title: this.deleteTitle,
        cancelbtn:'Volver',
        confirmbtn:'Confirmar',
        icon:'trash-2'
      };

      this.dialogService.open(options);
      this.dialogService.confirmed().subscribe(confirmed => {
        if(confirmed){
          this.delete.emit(param);
        }
      })
    }
}
